@if (pinCode) {
  <div>
    <div class="digit">{{ pinCode[0] }}</div>
    <div class="digit">{{ pinCode[1] }}</div>
    <div class="digit">{{ pinCode[2] }}</div>
    <div class="digit">{{ pinCode[3] }}</div>
    <div class="digit">{{ pinCode[4] }}</div>
    <div class="digit">{{ pinCode[5] }}</div>
  </div>
}
